import api from './authService';

export const getAuthUrl = () => {
  return api.get('/outlook-calendar/auth-url');
};

export const completeAuth = (code) => {
  return api.post('/outlook-calendar/callback', { code });
};

export const syncCalendar = (options = {}) => {
  return api.post('/outlook-calendar/sync', options);
};

export const getStatus = () => {
  return api.get('/outlook-calendar/status');
};

export const disconnect = () => {
  return api.post('/outlook-calendar/disconnect');
};
